"use client";

import React from "react";
import { ArrowRight, CirclePlay } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
export default function ModernGovernanceHero() {
  const [isTourOpen, setIsTourOpen] = React.useState(false);
  return <section id="modern-governance-hero" className="bg-background relative w-full overflow-hidden py-20 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/5 via-background to-background" />

      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:items-center">
          
          {}
          <div className="flex flex-col gap-8 lg:col-span-7">
            <div className="flex flex-col gap-6">
              <h3 className="text-foreground font-sans text-4xl md:text-5xl lg:text-[70px] font-bold leading-[1.1] tracking-tight">
                The Future of Public Administration <br className="hidden md:block" />
                <span className="text-primary">Built for Governments That Demand Certainty</span>
              </h3>
              
              <p className="text-foreground/80 max-w-2xl font-sans text-xl leading-relaxed md:text-[24px]">
                Strengthen national operations with Kanha Technology’s sovereign‑grade ERP—delivering secure, compliant, transparent performance across every ministry while elevating citizen services with modern, efficient workflows.
              </p>

            </div>

            <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
              <Link to="#consultation-portal">
                <Button size="lg" className="h-14 w-full px-8 text-lg sm:w-auto">
                  Schedule a Consultation
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
              <Link to="#tour">
              <Button variant="secondary" size="lg" className="h-14 w-full px-8 text-lg sm:w-auto" onClick={() => setIsTourOpen(true)}>
                <CirclePlay className="ml-2 size-5" />
                Platform Tour
              </Button>
              <span style={{
                display: "inherit",
                textAlign: "center",
                fontSize: "12px",
                lineHeight: "20px",
                fontWeight: "bold",
                position: "absolute"
              }}>
  Run Time: 7m:24s
</span></Link>
            </div>

            {}
            <div className="mt-4 flex items-center gap-4 text-sm font-medium text-muted-foreground">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map(i => <div key={i} className="border-background bg-muted flex size-8 items-center justify-center rounded-full border-2">
                    <span className="text-[10px] font-bold text-muted-foreground">
                      G{i}
                    </span>
                  </div>)}
              </div>
              <p>Trusted by 500+ Government Agencies.</p>
            </div>
          </div>

          {}
          <div className="relative lg:col-span-5">
            <div className="relative rounded-2xl bg-gradient-to-tr from-primary/10 to-secondary/10 p-2 shadow-2xl transition-transform duration-1000 hover:-translate-y-2">
              <div className="bg-card overflow-hidden rounded-xl border border-border/50 shadow-inner">
                <img src="/wp-content/uploads/2026/04/FrontPageNetwork.png" className="h-auto w-full object-cover object-center" alt="Kanha National Modernization platform demonstration preview" />
              </div>
              
              {}
              <div className="absolute -right-6 -top-6 -z-10 size-32 rounded-full bg-primary/20 blur-3xl" />
              <div className="absolute -bottom-8 -left-8 -z-10 size-40 rounded-full bg-secondary/20 blur-3xl" />
            </div>
          </div>

        </div>
      </div>

      <Dialog open={isTourOpen} onOpenChange={setIsTourOpen}>
        <DialogContent className="sm:max-w-5xl p-0 overflow-hidden border-none bg-black/95">
          <DialogHeader className="sr-only">
            <DialogTitle>Platform Tour Video</DialogTitle>
          </DialogHeader>
          <div className="aspect-video w-full">
            <video src="/wp-content/uploads/2026/04/Kanha-National-Modernization-v4_HD.mp4" controls playsInline autoplay className="h-full w-full" aria-label="Video demonstration of Kanha National Modernization platform" />
          </div>
        </DialogContent>
      </Dialog>
    </section>;
}